<script lang="ts">
  import { page } from '$app/stores';
  import { onMount } from 'svelte';

  import Login from './login.svelte';
  import Signup from './signup.svelte';
  import Reset from './reset.svelte';
  import CompleteReset from './complete-reset.svelte';
  import Drawer from '$components/drawer.svelte';

  import { drawer } from '$lib/stores/drawer';
  import { ACTION_PARAM, AUTH_DRAWER_IDS, RESET_PASSWORD_PARAM } from '$lib/constants';

  onMount(() => {
    if ($page.url.searchParams.has(RESET_PASSWORD_PARAM)) {
      drawer.open(AUTH_DRAWER_IDS.RESET_PASSWORD);
    }

    if (
      $page.url.searchParams.has(ACTION_PARAM) &&
      $page.url.searchParams.get(ACTION_PARAM) === 'login'
    ) {
      drawer.open(AUTH_DRAWER_IDS.LOGIN);
    }

    if (
      $page.url.searchParams.has(ACTION_PARAM) &&
      $page.url.searchParams.get(ACTION_PARAM) === 'signup'
    ) {
      drawer.open(AUTH_DRAWER_IDS.SIGNUP);
    }
  });
</script>

<Drawer id={AUTH_DRAWER_IDS.LOGIN}>
  <div class="p-4">
    <Login />
  </div>
</Drawer>

<Drawer id={AUTH_DRAWER_IDS.SIGNUP}>
  <div class="p-4">
    <Signup />
  </div>
</Drawer>

<Drawer id={AUTH_DRAWER_IDS.FORGOT_PASSWORD}>
  <div class="p-4">
    <Reset />
  </div>
</Drawer>

<Drawer id={AUTH_DRAWER_IDS.RESET_PASSWORD}>
  <div class="p-4">
    <CompleteReset />
  </div>
</Drawer>
